import { Component, input, output } from "@angular/core";

import { animate, state, style, transition, trigger } from "@angular/animations";

@Component({
  selector: "sidebar-filter-actions",
  imports: [],
  templateUrl: "./sidebar-filter-actions.component.html",
  styleUrls: ["./sidebar-filter-actions.component.scss"],
  animations: [
    trigger("slideInOut", [
      state(
        "in",
        style({
          transform: "translateY(0)"
        })
      ),
      transition("void => *", [style({ transform: "translateY(100%)" }), animate("300ms ease-in")]),
      transition("* => void", [animate("300ms ease-out", style({ transition: "translateY(100%" }))])
    ])
  ]
})
export class SidebarFilterActionsComponent {
  currentCount = input.required<number>();
  filtersStatus = input.required<boolean>();
  applyFilters = output<void>();
  clearFilters = output<void>();

  public onClearFilters(): void {
    this.clearFilters.emit();
  }

  public onApplyFilters(): void {
    this.applyFilters.emit();
  }
}
